import React from 'react';
import PropTypes from 'prop-types';
import Polyline from '@strava/ui/Map/Polyline';
import Colors from '@strava/ui/colors';

const PrivacyZonePolylines = ({
  polyline,
  privacyZoneFromStartIndex,
  privacyZoneFromEndIndex
}) => {
  const privacyZonePolylineStyle = {
    lineColor: Colors.N70_GRAVEL,
    outlineWidth: 5
  };

  return (
    <>
      <Polyline
        latLng={[...polyline.slice(0, privacyZoneFromStartIndex)]}
        id="privacy-polyline-start"
        style={privacyZonePolylineStyle}
      />

      <Polyline
        latLng={[
          ...polyline.slice(
            polyline.length - privacyZoneFromEndIndex,
            polyline.length - 1
          )
        ]}
        id="privacy-polyline-end"
        style={privacyZonePolylineStyle}
      />
    </>
  );
};

PrivacyZonePolylines.propTypes = {
  polyline: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  privacyZoneFromStartIndex: PropTypes.number.isRequired,
  privacyZoneFromEndIndex: PropTypes.number.isRequired
};

export default PrivacyZonePolylines;
